import styles from './GiftModal.module.css'
import Modal from "../../../components/Modal/Modal.tsx";
import GiftItem from "../GiftItem/GiftItem.tsx";

const GiftModal = ({img, amount}: {img: string, amount: number}) => {

    const sendMessage = () => {
        const url = "https://t.me/zelinskiy1"
        window.Telegram?.WebApp.openTelegramLink(url)
    }

    return (
        <Modal noTopPadding={true}>
            <div className={styles.container}>
                <div className={styles.title}>Green Box</div>
                <div className={styles.giftItem}><GiftItem img={img} amount={amount}/></div>
                <div className={styles.stepsContainer}>
                    <div className={styles.stepsTitle}>Выполни эти действия чтобы вывести подарок:</div>
                    <div className={styles.stepsBlock}>
                        <div className={styles.step}>
                            <div className={styles.stepNumber}>
                                1
                            </div>
                            <p className={styles.stepText}>Нажми на кнопку <span>“Написать в телеграм”</span> и открой
                                чат с нам</p>
                        </div>

                        <div className={styles.step}>
                            <div className={styles.stepNumber}>
                                2
                            </div>
                            <p className={styles.stepText}>Напиши любое сообщение в чат</p>
                        </div>

                        <div className={styles.step}>
                            <div className={styles.stepNumber}>
                                3
                            </div>
                            <p className={styles.stepText}>Вернись в приложение и нажми на кнопку <span>“Вывести подарок”</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className={styles.stepsButton}>
                    <button onClick={sendMessage}>Написать в телеграм</button>
                    <button>Вывести подарок</button>
                </div>
            </div>
        </Modal>
    )
}

export default GiftModal;